'use strict';

angular.module('client.services').factory('cleverService', ['$resource', '$q', '$log', 'api_server',
  function ($resource, $q, $log, api_server) {
    const rosterSyncDisabledMessage = 'Clever roster sync is not enabled for your district';
    const rosterSyncDisabledReasons = {
      cleverRosterSyncDisabled: true,
      noAccessToken: true
    };

    const importableClassesResource = $resource(api_server + '/clever/classes/importable', {}, {
      get: { method: 'GET' }
    });

    const importResource = $resource(api_server + '/unified/classes/create', {}, {
      post: { method: 'POST' }
    });

    function isLoggedInWithClever(user) {
      return String(user && user.loggedBy || '').toLowerCase() === 'clever';
    }

    function getImportableClasses(user) {
      if (!user || !user.clever_user || !isLoggedInWithClever(user)) {
        return $q.when({ courses: [], isCleverClassroomUser: false });
      }

      return importableClassesResource.get().$promise
        .then(function (response) {
          const classes = (response && Array.isArray(response.classes)) ? response.classes : [];
          const reason = response && response.reason;
          return {
            courses: classes.map(function (cleverClass) {
              const displayName = (cleverClass && (cleverClass.title || cleverClass.name || cleverClass.className)) ||
                (cleverClass && cleverClass.classSourcedId) ||
                '';
              return {
                name: displayName,
                classSourcedId: cleverClass && cleverClass.classSourcedId,
                tenantId: cleverClass && cleverClass.tenantId,
                schoolId: cleverClass && (cleverClass.schoolId || cleverClass.explorosSchoolId),
                cleverSchoolId: cleverClass && cleverClass.cleverSchoolId,
                enrollmentSourcedId: cleverClass && cleverClass.enrollmentSourcedId,
                operation: cleverClass && (cleverClass.op || cleverClass.operation)
              };
            }),
            disabledMessage: rosterSyncDisabledReasons[reason] ? rosterSyncDisabledMessage : null,
            reason: reason,
            isCleverClassroomUser: true
          };
        })
        .catch(function (error) {
          $log.error('Clever importable-classes error:', error);
          return { courses: [], isCleverClassroomUser: false };
        });
    }

    function importCourse(selectedClass, params) {
      const body = {
        integrationId: -7,
        ims: {
          integrationId: -7,
          tenantId: selectedClass.tenantId,
          classSourcedId: selectedClass.classSourcedId
        },
        tenantId: selectedClass.tenantId,
        classSourcedId: selectedClass.classSourcedId,
        schoolId: selectedClass.schoolId,
        title: selectedClass.name,
        teacherId: params.teacherId,
        enrollmentSourcedId: selectedClass.enrollmentSourcedId || null
      };
      if (params.grade !== undefined && params.grade !== null) body.grade = params.grade;
      if (params.subject !== undefined && params.subject !== null) body.subject = params.subject;
      if (params.licenses !== undefined && Array.isArray(params.licenses) && params.licenses.length > 0) body.licenses = params.licenses;

      return importResource.post({}, body).$promise.then(function (res) {
        const addedStudents = res && res.studentAdds || 0;
        return {
          cid: res && (res.cid || res.classId),
          className: res && res.className,
          added: addedStudents,
          addedStudents: addedStudents,
          failedStudents: res && res.failedStudents,
          failedDomainStudents: res && res.failedDomainStudents,
          sufficientSeats: !res || res.sufficientSeats !== false
        };
      });
    }

    return {
      isLoggedInWithClever: isLoggedInWithClever,
      getImportableClasses: getImportableClasses,
      importCourse: importCourse
    };
  }]);
